import { Injectable, EventEmitter } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ErrorEmitterService {
  public errorBool = new EventEmitter();
  constructor() {}

  sendError(bool: boolean) {
    this.errorBool.emit(bool);
  }
}
